// ── Supabase config ───────────────────────────────────────────────────────────
export const SUPABASE_URL     = 'https://qwdmftzltghajlcbwcnz.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF3ZG1mdHpsdGdoYWpsY2J3Y256Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk0MzE3NzEsImV4cCI6MjA5NTAwNzc3MX0.wF-syvlIh9_4aXktZSgfpMmNrbx6jtYqzP4urCE-PJU';

// ── Roles available per station type (static — not driven by DB) ──────────────
export const ROLES_BY_STATION_TYPE = {
  both: [
    { value: 'structural', label: 'Structural Firefighter' },
    { value: 'rural',      label: 'Rural Only Firefighter' },
    { value: 'ops',        label: 'Operational Support' },
    { value: 'brigade',    label: 'Brigade Support' },
  ],
  rural: [
    { value: 'rural', label: 'Rural Only Firefighter' },
  ],
};

// ── Gender sets — items shown only to one gender ──────────────────────────────
export const MALE_ONLY_ITEMS = new Set([
  'Dark Blue Shirt (Male)',
  'T-Shirt (Mens/Unisex)',
  'Soft Shell Jacket (Male)',
  'Urban Level 1 Trousers (Male)',
  'Urban Level 1 Coverall (Male)',
  'Rural Wildland Jacket (Kavin) Male',
  'Rural Wildland Trousers (Kavin) Male',
  'Dress Shirt – Light Blue (Male)',
  'Dress Trousers (Male)',
  'Dress Jacket (Male)',
  'Dress Shoes (Male US)',
]);

export const FEMALE_ONLY_ITEMS = new Set([
  'Dark Blue Shirt (Female)',
  'T-Shirt (Female Fit)',
  'Soft Shell Jacket (Female)',
  'Urban Level 1 Trousers (Female)',
  'Urban Level 1 Coverall (Female)',
  'Rural Wildland Jacket (Kavin) Female',
  'Rural Wildland Trousers (Kavin) Female',
  'Dress Shirt – Light Blue (Female)',
  'Dress Trousers (Female)',
  'Dress Skirt (Female)',
  'Dress Jacket (Female)',
  'Dress Shoes (Female US)',
  'Ladies Court Shoes (US)',
]);

// ── Helmet items merged into a single variant selector ────────────────────────
export const HELMET_ITEMS = new Set([
  'Structural Helmet – Firefighter (Yellow)',
  'Structural Helmet – Officer (Red)',
]);

// ── Structural jacket/trouser sizing (Totalcare — no inventory rows) ──────────
export const STRUCTURAL_SIZING = {
  lengths: ['Short', 'Regular', 'Tall', 'X Tall'],
  sizes:   ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'],
};

// ── Custom size order for specific items ──────────────────────────────────────
export const ITEM_SIZE_ORDER = {
  'Epaulettes': [
    'Recruit Firefighter',
    'Firefighter',
    'Qualified Firefighter',
    'Senior Firefighter',
    'Station Officer',
    'Senior Station Officer',
  ],
};
